<template>
    <div>
        <el-form :model="searchForm" :inline="true" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="订单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="退款状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option label="待处理" value="0"></el-option>
                    <el-option label="审核通过（打款）" value="1"></el-option>
                    <el-option label="审核通过（不打款）" value="2"></el-option>
                    <el-option label="审核不通过" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain @click="getListPageHandle" icon="el-icon-search">搜 索</el-button>
                <el-button type="success" plain icon="el-icon-download" @click="confirmExportDialogVisible = true">导 出</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		> 
            <el-table-column type="index" width="50" label="序号" align="center"></el-table-column> 
            <el-table-column prop="orderNo" label="订单号" align="center"></el-table-column>
            <el-table-column label="ICCID号"  align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" align="center" label="申请退款时间" width="140"></el-table-column>
            <el-table-column prop="stateName" align="center" label="退款状态" width="80"></el-table-column>
            <el-table-column prop="priceRmb" align="center" label="订单金额（元）" width="110"></el-table-column>
            <el-table-column prop="rqReason" align="center" label="退款原因"></el-table-column>
            <el-table-column prop="createOptName" align="center" label="申请人" width="100"></el-table-column>
            <el-table-column prop="rpTime" align="center" label="审核时间" width="140"></el-table-column>
            <el-table-column prop="rpReason" align="center" label="审核结果" width="120"></el-table-column>
            <el-table-column label="操作" width="120" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showBackMoneyDetailDialog(scope.row.orderNo, $event)">详情</el-button>
                    <el-button type="text" size="small" @click="showComplainatPhotos(scope.row)">证据截图</el-button>
                    
                </template>            
            </el-table-column>
        </el-table>       
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true"  title="退款详情" :visible.sync="backMoneyDetailVisible" width="1000px" :close-on-click-modal="false">
            <el-table :data="tbpg_back.tableData" border height="421">
                <el-table-column prop="orderNo" label="订单号" width="240"></el-table-column>
                <el-table-column prop="agentName" label="代理商名称"></el-table-column>
                <el-table-column prop="commissionRmb" label="退款金额（元）"></el-table-column>
                <el-table-column prop="remark" label="退款原因"></el-table-column>
            </el-table> 
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_back.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_back.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_back.total">
            </el-pagination> 
        </el-dialog>
        <el-dialog :append-to-body="true"  title="证据截图" :visible.sync="complainatPhotosVisible" width="1000px" :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订&nbsp;单&nbsp;号：</label>
                <span>{{backMoneyDetail.orderNo}}</span>
            </div>
            <div class="lineInDialog">
                <label>ICCID号：</label>
                <span>{{backMoneyDetail.iccid}}</span>
            </div>

            <div class="lineInDialog">
                <label>证据截图：</label>
                <el-image v-for="url in backMoneyDetail.complainatPhotos" 
                class="complainatPhotos"
                :key="url" :src="url" 
                :preview-src-list="backMoneyDetail.complainatPhotos" lazy></el-image>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="complainatPhotosVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportInfoHandle">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {backMoneyList, getSecondBackList } from '@/api/order.js'
import {exportBackMoneyApplyInfo } from '@/api/csm.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                agentName: '',
                supplierCode: '',
                iccid: '',
                orderNo: '',
                time: '',
                state: '',
                backOrderNo:''
            },
            branchSupplierOption: [],
            //退款订单列表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            //退款详情
            tbpg_back: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },          
            publishNotifyVisibale: false,
            publishNotifyForm: {
                title: '',
                content: ''
            },
            complainatPhotosVisible: false,//证据截图显示框
            backMoneyDetail: {//退款详情对象
                orderNo:'',
                iccid:'',
                complainatPhotos:[],//退款证据截图数组
            },
            confirmDialogVisible : false,//确认框
            backMoneyDetailVisible: false, //退款详情

            confirmExportDialogVisible : false,//导出确认框
        }
    },
    methods: {
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            backMoneyList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val){
            if(this.backVisible){
                this.tbpg_back.pageSize = val;
                this.showSecondBackList(this.currentOrderNo_back);
            }else{
                this.tbpg.pageSize = val;
                this.getListPageHandle();
            }

        },
        handleCurrentChange(val){
            if(this.backVisible){
                this.tbpg_back.currentPage = val;
                this.showSecondBackList(this.currentOrderNo_back);
            }else{
                this.tbpg.currentPage = val
                this.getListPageHandle();                
            }
        },
        //“退款详情” 
        showBackMoneyDetailDialog(orderNo, $event){
            this.backMoneyDetailVisible = true;
            this.currentOrderNo_back = orderNo
            var searchForm = {
                orderNo: this.currentOrderNo_back
            }
            common.resetCurrentPage(this, $event, 'tbpg_back');
            var data = common.getRequestParams(this, 'tbpg_back', searchForm);
            getSecondBackList(data).then(res => {
                common.listCallback(this, res, 'tbpg_back');
            })
        },
        //证据截图对话框
        showComplainatPhotos(row){
            this.complainatPhotosVisible = true;
            this.backMoneyDetail.orderNo = row.orderNo;
            this.backMoneyDetail.iccid = row.iccid;
            this.backMoneyDetail.orderNo = row.orderNo;

            let photosArray = row.payImgUrl.split("@@");
            for(let i=0; i<photosArray.length; i++){
                this.backMoneyDetail.complainatPhotos[i] = process.env.VUE_APP_IMG_URL + '/' + photosArray[i];
            }
        },
        exportInfoHandle(){
            exportBackMoneyApplyInfo({}).then(res =>{
                if(res.data.code == 200){
                    this.$message.success('数据导出中,请稍候去任务中心下载');
                }else{
                    this.$message.error(res.data.msg);
                }
                this.confirmExportDialogVisible = false;
            }).catch(err=>console.error(err));
        },
    
    },
    created () {
        this.getListPageHandle();
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
    } 
}
</script>
<style lang="less">
.notifyDetail {
    h3 {
        text-align: center;
        margin-bottom: 10px;
    }
    p {
        text-indent: 2em;
        line-height: 1.5em;
    }
}
</style>

